// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3oH6v","rootCenter":"LoadMoreObserver_rootCenter__2yeu4","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__k9LzC"};